// assets
import {
  ChromeOutlined,
  QuestionOutlined,
  AppstoreAddOutlined,
} from "@ant-design/icons";
import BookmarkAddedIcon from '@mui/icons-material/BookmarkAdded';

// icons
const icons = {
  ChromeOutlined,
  QuestionOutlined,
};

// ==============================|| MENU ITEMS - SAMPLE PAGE & DOCUMENTATION ||============================== //

const BoardsAndPanel = {
  id: "Boards & Panel",
  title: "Boards & Panel",
  type: "group",
  children: [
    {
      id: "Boards & Panel",
      title: "Boards & Panel",
      type: "collapse",
      url: "/BoardsAndPanel",
      icon: BookmarkAddedIcon,
      children: [
          {
          id: "Boards & Panel",
          title:"Board Of Arbitrators",
          type: "item",
          url: "/boardsAndPanel/BoardOfArbitrators",
           icon: AppstoreAddOutlined,
        },
         {
          id: "Boards & Panel",
          title:"Board Of Mediators",
          type: "item",
          url: "/boardsAndPanel/BoardOfMediator",
           icon: AppstoreAddOutlined,
        },
      ],
    },
  ],
};

export default BoardsAndPanel;
